import type { TFunction } from 'i18next';
import type { PurchaseOrderActivityItem } from '../types/purchase-order-activity-item';
import { PurchaseOrderActivityDocumentDeleted } from './purchase-order-activity-document-deleted';
import { PurchaseOrderActivityDocumentSent } from './purchase-order-activity-document-sent';
import { PurchaseOrderActivityDocumentUploaded } from './purchase-order-activity-document-uploaded';

type RenderDocumentActivityProps = {
  activity: PurchaseOrderActivityItem;
  documentUrlByName: Record<string, string>;
  t: TFunction<'purchaseOrder'>;
};

export function renderDocumentActivity({
  activity,
  documentUrlByName,
  t,
}: RenderDocumentActivityProps) {
  switch (activity.eventCode) {
    case 'purchase_order_document_uploaded':
      return (
        <PurchaseOrderActivityDocumentUploaded
          activity={activity}
          documentUrlByName={documentUrlByName}
          t={t}
        />
      );
    case 'purchase_order_document_deleted':
      return <PurchaseOrderActivityDocumentDeleted activity={activity} t={t} />;
    case 'purchase_order_sent_to_supplier':
    case 'purchase_order_signed_proforma_sent':
    case 'purchase_order_unsigned_proforma_sent':
      return (
        <PurchaseOrderActivityDocumentSent
          activity={activity}
          documentUrlByName={documentUrlByName}
          t={t}
        />
      );
    default:
      return null;
  }
}
